import type { FunctionComponent } from 'react';
import { TopNavigation } from '@atlaskit/page-layout';
import {
  TopNav,
  TopNavStart,
  TopNavEnd,
} from '@atlaskit/navigation-system/layout/top-nav';
import { CustomLogo } from '@atlaskit/navigation-system/top-nav-items';
import {
  AtlassianLogo,
  AtlassianIcon,
  TrelloLogo,
  TrelloIcon,
} from '@atlaskit/logo';
import Account from '@atlassian/account/nav4';
import { Box, xcss } from '@atlaskit/primitives';
import { Show } from '@atlaskit/primitives/responsive/show';
import { Hide } from '@atlaskit/primitives/responsive/hide';
import { getConfig } from '../../config/envConfig';
import { useToken } from '../Flow/ConsentContextProvider';
import { useAccountProps } from './NavContents/useAccountProps';
import NavContents from './NavContents';

const Navigation: FunctionComponent = () => {
  return (
    <TopNavigation>
      <NavContents />
    </TopNavigation>
  );
};

const staticBrandStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  paddingInline: 'space.050',
  marginInlineStart: 'space.050',
});

export const Nav4 = () => {
  const { serviceType } = useToken();
  const accountProps = useAccountProps();
  const isTrello = serviceType === 'Trello';
  const brand = isTrello ? 'Trello' : 'Atlassian';
  const Logo = isTrello ? TrelloLogo : AtlassianLogo;
  const Icon = isTrello ? TrelloIcon : AtlassianIcon;
  const config = getConfig();
  const homeUrl = isTrello
    ? `https://${config.trello.webHost}`
    : config.navigation.homeUrl;

  return (
    <TopNav>
      <TopNavStart sideNavToggleButton={null}>
        {homeUrl ? (
          <CustomLogo
            href={homeUrl}
            label={`${brand} Home`}
            logo={Logo}
            icon={Icon}
          />
        ) : (
          <Box role="img" aria-label={brand} xcss={staticBrandStyles}>
            <Hide above="md">
              <Icon size="small" appearance="brand" label="" />
            </Hide>
            <Show above="md">
              <Logo size="small" appearance="brand" label="" />
            </Show>
          </Box>
        )}
      </TopNavStart>
      <TopNavEnd>
        <Account {...accountProps} />
      </TopNavEnd>
    </TopNav>
  );
};

export default Navigation;
